import { render, staticRenderFns } from "./DefaultUserIcon.vue?vue&type=template&id=1493e560&"
import script from "./DefaultUserIcon.vue?vue&type=script&lang=js&"
export * from "./DefaultUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports